import React, { useState, useEffect } from "react"; // rafce
import {
  FaBars,
  FaGithub,
  FaLinkedin,
  FaTimes,
  FaTwitter,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import Logo from "../assets/logo.png";
import { Link } from "react-scroll";
import MonCv from "../assets/mes_documents/myCV_ENGLISH.pdf"

const Navbar = () => {
  const [nav, setNav] = useState(false);
  // Method handle click toggle to the opposite value
  const handleClick = () => {
    setNav(!nav);
  };
  const [hideIcons, setHideIcons] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setHideIcons(true);
      } else {
        setHideIcons(false);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300">
      <div className="cursor-pointer">
        <Link to="home" smooth={true} offset={-70} duration={500}>
        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
        <img src={Logo} alt="Logo Image" style={{ width: "150px" }} />
          </Link>
      </div>

      {/* menu */}
      <ul className="hidden md:flex">
        <li>
          <Link to="home" smooth={true} offset={-70} duration={500}>
            Home
          </Link>
        </li>
        <li>
          <Link to="about" smooth={true} offset={-70} duration={500}>
            About
          </Link>
        </li>
        <li>
          <Link to="skills" smooth={true} offset={-70} duration={500}>
            Skills
          </Link>
        </li>
        <li>
          <Link to="work" smooth={true} offset={-70} duration={500}>
            Work
          </Link>
        </li>
        <li>
          <Link to="contact" smooth={true} offset={-70} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Drop down Menu */}
      <div onClick={handleClick} className="md:hidden z-10">
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile Menu */}
      <ul
        className={
          !nav
            ? "hidden"
            : "absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center"
        }
      >
        <li className="py-6 text-4xl">
          <Link onClick={handleClick} to="home" smooth={true} offset={-70} duration={500}>
            Home
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link onClick={handleClick} to="about" smooth={true} offset={-70} duration={500}>
            About
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link onClick={handleClick} to="skills" smooth={true} offset={-70} duration={500}>
            Skills
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link onClick={handleClick} to="work" smooth={true} offset={-70} duration={500}>
            Work
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link onClick={handleClick} to="contact" smooth={true} offset={-70} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Social media icons */}
      {/* This div element is for larger screens and contains a fixed flex-column with top and left offsets */}
      <div className="hidden lg:block fixed flex-col top-[35%] left-[-35px]">
        <ul className="w-160 h-60">
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[30px] duration-300 bg-blue-600">
            <a
              href="https://www.linkedin.com/in/ismail-bassaoud/"
              className="flex justify-between items-center w-full text-gray-300"
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[30px] duration-300 bg-[#333333]">
            <a
              href="https://github.com/IBassaoud"
              className="flex justify-between items-center w-full text-gray-300"
            >
              GitHub <FaGithub size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[30px] duration-300 bg-blue-600">
            <a
              href="https://twitter.com/ism34_dev"
              className="flex justify-between items-center w-full text-gray-300"
            >
              Twitter <FaTwitter size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[30px] duration-300 bg-[#6fc2b0]">
            <a
              href="mailto: ismail.bassaoud@gmail.com"
              className="flex justify-between items-center w-full text-gray-300"
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[30px] duration-300 bg-[#565f69]">
            <a
              href={MonCv}  
              className="flex justify-between items-center w-full text-gray-300"
            >
              Resume <BsFillPersonLinesFill size={30} />
            </a>
          </li>
        </ul>
      </div>

      {/* Social media icons for smaller screens */}
      {!hideIcons && (
      <div className="block lg:hidden fixed bottom-0 right-0 p-6">
        <a
          href="https://www.linkedin.com/in/ismail-bassaoud/"
          className="text-gray-300 mr-6"
        >
          <FaLinkedin size={30} />
        </a>
        <a
          href="https://github.com/IBassaoud"
          className="text-gray-300 mr-6"
        >
          <FaGithub size={30} />
        </a>
        <a
          href="https://twitter.com/ism34_dev"
          className="text-gray-300 mr-6"
        >
          <FaTwitter size={30} />
        </a>
        <a
          href="mailto: ismail.bassaoud@gmail.com"
          className="text-gray-300 mr-6"
        >
          <HiOutlineMail size={30} />
        </a>
        <a
          href={MonCv}
          className="text-gray-300"
        >
          <BsFillPersonLinesFill size={30} />
        </a>
      </div>
    )}
    </div>
  );
};

export default Navbar;
